import { render, staticRenderFns } from "./addPersonnel.vue?vue&type=template&id=da0afee6&scoped=true"
import script from "./addPersonnel.vue?vue&type=script&lang=js"
export * from "./addPersonnel.vue?vue&type=script&lang=js"
import style0 from "./addPersonnel.vue?vue&type=style&index=0&id=da0afee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0afee6",
  null
  
)

export default component.exports